import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useWebgate } from '@xvia/webgate-connect';

export const Profile = () => {
  const { accessToken, userInfo } = useWebgate();

  return (
    <Box>
      <Card sx={{ py: 2, px: 6 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" gutterBottom>
              Perfil do usuário
            </Typography>
            <hr />
            {userInfo ? (
              <>
                <Typography component="div">
                  <Box fontWeight="bold">
                    Usuário:{' '}
                    <Box fontWeight="normal" display="inline">
                      {userInfo.name}
                    </Box>
                  </Box>
                  <Box fontWeight="bold">
                    E-mail:{' '}
                    <Box fontWeight="normal" display="inline">
                      {userInfo.email}
                    </Box>
                  </Box>
                </Typography>
                {accessToken && (
                  <Typography component="div" style={{ wordWrap: 'break-word' }}>
                    <Box fontWeight="bold">
                      Token:{' '}
                      <Box fontWeight="normal" display="inline">
                        {accessToken}
                      </Box>
                    </Box>
                  </Typography>
                )}
              </>
            ) : (
              <Typography variant="subtitle1" align="center">
                Inicie a sessão para obter informações do usuário.
              </Typography>
            )}
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};
